export default class QuicklinksOverflow {
    constructor(element) {
        this.wrapper = element;
        this.content = this.wrapper.querySelector('.c-quicklinks__links');

        if (!this.content) return;

        this.bindEvents();
        this.updateShadows();
    }

    bindEvents() {
        this.content.addEventListener('scroll', () => this.updateShadows());
        window.addEventListener('resize', () => this.updateShadows());
    }

    updateShadows() {
        const { scrollTop, scrollHeight, clientHeight } = this.content;

        const canScroll = scrollHeight > clientHeight;
        const atTop = scrollTop === 0;
        const atBottom = scrollTop + clientHeight >= scrollHeight - 1; // account for float by rounding

        this.content.classList.toggle('has-top-shadow', canScroll && !atTop);
        this.content.classList.toggle('has-bottom-shadow', canScroll && !atBottom);
    }
}